const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');

// @ commons
import OKLayout from 'components/commons/OKLayout/OKLayout';
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const { getLastNChars } = require('utilities/stringHelper');

// @ actions
const accountCancelChequesActions = require('actions/accountCancelCheques');
const accountChequebookActions = require('actions/accountChequebook');

// @ components
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');
const { AccountCancelChequesStep1 } = require('components/accounts/accountCancelChequesSteps/accountCancelChequesStep1/accountCancelChequesStep1');
const AccountCancelChequesStep2 = require('components/accounts/accountCancelChequesSteps/accountCancelChequesStep2/accountCancelChequesStep2');
const AccountCancelChequesSuccessStep = require('components/accounts/accountCancelChequesSteps/accountCancelChequesSuccessStep/accountCancelChequesSuccessStep');
const AccountDetailsSideBar = require('components/accounts/accountDetailsSidebar/accountDetailsSidebar');
import extendAccountFunctionality from 'components/accounts/extendAccountFunctionality/extendAccountFunctionality';

//@utilities
const AccessHelper = require('utilities/accessHelper');
//@constants
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
import { NEGATIVE } from 'constants/layout';

class AccountCancelChequesView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleCancelCheque = this.handleCancelCheque.bind(this);
    }

    componentDidMount() {
        const { history, immAccounts, requestChequebook, match: { params: { accountId, chequebookIndex } } } = this.props;

        AccessHelper.allowAccess(accountConstants.ACCOUNTS_CANCEL_CHEQUE, { immAccounts, accountId }, history);

        requestChequebook(accountId, chequebookIndex);
    }

    componentWillUnmount() {
        this.props.resetView();
    }

    onCancel() {
        const { history, match: { params: { accountId } } } = this.props;
        history.push(`/myprofile/accounts/${accountId}/cheques`);
    }

    buildError() {
        const { match: { params: { accountId } } } = this.props;
        const errorTitle = formatText('accountCancelCheques-errorTitle');
        const errorMessage = formatText('accountCancelCheques-errorMessage');
        const goBackButtonLabel = formatText('accountCancelCheques-errorBackToChequesLink').toUpperCase();
        const linkToCheques = `/myprofile/accounts/${accountId}/cheques`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToCheques
        }
        return (
            <WizardError
                errorMessage={errorTitle}
                errorSubMessage={errorMessage}
                mainButton={goBackButton}
            />
        );
    }

    buildSuccessful() {
        const { match: { params: { accountId } }, immAccountCancelCheques } = this.props;
        const immSteps = immAccountCancelCheques.get('steps');
        const chequeNumber = immSteps.get(0).get('number');
        const backUrl = `/myprofile/accounts/${accountId}/cheques`;
        return (
            <div className="row no-outside-gutter">
                <div className="col-xs-offset-2 col-xs-8 one-column">
                    <AccountCancelChequesSuccessStep
                        backUrl={backUrl}
                        chequeNumber={chequeNumber}
                    />
                </div>
            </div>
        )
    }

    handleCancelCheque() {
        const { match: { params: { accountId } }, cancelCheque } = this.props;
        cancelCheque(accountId);
    }

    render() {
        const { match: { params: { accountId, chequebookIndex } }, immAccounts, immAccountsCheques, immAccountCancelCheques, handleOptionsClick } = this.props;
        const immSteps = immAccountCancelCheques.get('steps');
        const visibleStep = immAccountCancelCheques.get('visibleStep');
        const immAccount = immAccounts.get('byId').get(accountId);
        const actions = {
            validateStep: this.props.validateStep,
            setWillCancel: this.props.setWillCancel,
            setVisibleStep: this.props.setVisibleStep,
            finish: this.handleCancelCheque,
            cancel: this.onCancel
        };
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: immAccount.get('alias'),
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('accountCheques-chequebooks'),
                url: `/myprofile/accounts/${accountId}/cheques`
            },
            {
                text: formatText('accountCheques-cancelCheques')
            }
        ];
        const subtitleLeft = immAccount.get('catalogData').get('subtype');
        const subtitleRight = getLastNChars(immAccount.get('iban'));
        let bodyBlock;

        if (immAccountCancelCheques.get('submitSuccessful')) {
            bodyBlock = this.buildSuccessful();
        } else if (immAccountCancelCheques.get('error')) {
            bodyBlock = this.buildError();
        } else {
            const immCheques = immAccountsCheques.get(accountId);
            const chequebookId = immCheques && immCheques.getIn(['byOrder', chequebookIndex]);
            const immCheque = chequebookId && immCheques.getIn(['byId', chequebookId]);
            const isFetching = immAccountCancelCheques.getIn(['steps', 0, 'apiValidationInProgress']);

            bodyBlock = immCheque && (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8">
                        <Wizard
                            wizardClass={'account-cancel-cheques-view__wizard'}
                            actions={actions}
                            immSteps={immSteps}
                            stepsAmount={immSteps.size}
                            visibleStep={visibleStep}
                            isFetching={isFetching}
                            showPreLeaveModal
                        >
                            <WizardStep position="first" cancelButton={true}>
                                <AccountCancelChequesStep1
                                    immCheque={immCheque}
                                    immAccountCancelCheques={immAccountCancelCheques}
                                    immAccount={immAccount}
                                    chequebookIndex={chequebookIndex}
                                />
                            </WizardStep>
                            <WizardStep
                                addLoadingBehaviour
                                position="last"
                                immFinalButton="accountCancelCheques-finalButtonLabel"
                                cancelButton
                            >
                                <AccountCancelChequesStep2
                                    immAccounts={immAccounts}
                                    accountId={accountId}
                                    immStep={immSteps.get(0)}
                                />
                            </WizardStep>
                        </Wizard>
                    </div>
                    <div className="col-xs-4">
                        <AccountDetailsSideBar immAccount={immAccount} />
                    </div>
                </div>
            );
        }

        return (
            <OKLayout
                breadcrumb={mappingBreadcrumb}
                buttons={<AccountMoreOptionsButton accountId={accountId} onOptionClick={handleOptionsClick} />}
                contentPosition={NEGATIVE}
                title={getFinalTitle('accountCheques-cancelCheques')}
                loading={!immAccount}
                section="accounts"
                subtitleLeft={subtitleLeft}
                subtitleRight={subtitleRight}
            >
                {bodyBlock}
            </OKLayout>
        );
    }
}

AccountCancelChequesView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountsCheques: PropTypes.object.isRequired,
    immAccountCancelCheques: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    cancelCheque: PropTypes.func.isRequired,
    resetView: PropTypes.func.isRequired,
    requestChequebook: PropTypes.func.isRequired
};

module.exports.constructor = AccountCancelChequesView;
module.exports.AccountCancelChequesView = connect(
    state => ({
        immAccounts: state.accounts,
        immAccountCancelCheques: state.accountCancelCheques,
        immAccountsCheques: state.accountsCheques
    }), {
    requestChequebook: accountChequebookActions.requestChequebook,
    validateStep: accountCancelChequesActions.validateStep,
    setWillCancel: accountCancelChequesActions.setWillCancel,
    setVisibleStep: accountCancelChequesActions.setVisibleStep,
    cancelCheque: accountCancelChequesActions.cancelCheque,
    resetView: accountCancelChequesActions.resetView
})(withRouter(extendAccountFunctionality(AccountCancelChequesView)));
